import React, {useEffect, useState, useMemo} from 'react';
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";
import {connect} from 'react-redux';
import ReactMarkdown from 'react-markdown'
import NotFound from './NotFound'

import gfm from 'remark-gfm'
import math from 'remark-math'
import frontmatter from 'remark-frontmatter'
import rehypeRaw from 'rehype-raw'
const { parseMarkdownFrontmatter } = require('../utils/safeFrontmatter');
const { loadBundledMarkdown } = require('../utils/loadBundledMarkdown');


function Articles({
  article,
}) {

  const [markdown, setMarkdown] = useState(null)
  const [yamlProperties, setYamlProperties] = useState(null)

  useEffect(() => {
    if (!article?.slug) {
      setMarkdown(null);
      setYamlProperties(null);
      return;
    }

    let cancelled = false;

    loadBundledMarkdown(article.slug)
      .then((text) => {
        if (cancelled) {
          return;
        }
        setMarkdown(text);
        setYamlProperties(parseMarkdownFrontmatter(text));
      })
      .catch(() => {
        if (cancelled) {
          return;
        }
        setMarkdown(null);
        setYamlProperties(null);
      });

    return () => {
      cancelled = true;
    };
  }, [article?.slug]);

  if(!markdown)
    return <NotFound />

  return (

    <>

      <Helmet>
          <title>{yamlProperties && yamlProperties.seoTitle}</title>
          <meta name="description" content={yamlProperties?.description} />
          <link rel="canonical" href={yamlProperties && yamlProperties.canonical} />
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-start-1 lg:col-end-8 lg:text-left lg:flex lg:items-center">
              <div>
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  {yamlProperties && yamlProperties.titleLine1}
                  <br className="hidden md:inline"/>
                  <span className="text-orange-400">{yamlProperties && yamlProperties.titleLine2}</span>
                </h1>

                  <ReactMarkdown
                    children={yamlProperties && yamlProperties.intro}
                    components={{
                      p: ({children}) => (
                        <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                          {children}
                        </p>
                      )
                    }}
                  />

              </div>
            </div>
          </div>
        </div>
      </main>

      <div className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 space-y-8 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-start">
            <div className="relative z-10">
              <div className="prose prose-orange text-gray-500 mx-auto lg:max-w-none">
                <ReactMarkdown
                  children={markdown}
                  remarkPlugins={[gfm,math,[frontmatter, ['yaml','toml']]]}
                  rehypePlugins={[rehypeRaw]}
                >
                </ReactMarkdown>
              </div>
              {/*<div className="mt-10 flex text-base max-w-prose mx-auto lg:max-w-none">
                <div className="rounded-md shadow">
                  <a href="#" className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700">
                    Contact sales
                  </a>
                </div>
                <div className="rounded-md shadow ml-4">
                  <a href="#" className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-orange-600 bg-white hover:bg-gray-50">
                    Learn more
                  </a>
                </div>
              </div>*/}
            </div>

          </div>
        </div>
      </div>


      <div className="bg-orange-700">
        <div className="max-w-2xl mx-auto text-center py-16 px-4 sm:py-20 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            <span className="block">Say hello to easy payslips.</span>
            <span className="block">Start using Buddy today.</span>
          </h2>
          <p className="mt-4 text-lg leading-6 text-orange-200">Buddy has Malta's easiest to understand payslips. <br/>It's super easy to use with no previous experience required.</p>
          <Link to="/" className="mt-8 w-full inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-orange-600 bg-white hover:bg-orange-50 sm:w-auto">
            Try Buddy for free
          </Link>
        </div>
      </div>

    </>

  );
}

const mapStateToProps = (state,ownProps) => {

  const articleSlug = ownProps.slug
  console.log('articleSlug',articleSlug,ownProps)

  const articles = state.articles

  const currentArticle = (articles?.find?.(article => article.slug == articleSlug))

  return {
    articleSlug,
    article: currentArticle,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Articles)
